import { routes } from "../../constants/routes";
export const breadcrumbLink = [
  {
    label: "Customer Management",
    link: routes.CUSTOMERLIST,
    handleClick: () => {},
  },
  {
    label: "Customer Profile",
    link:routes.CUSTOMERLIST,
    handleClick: () => {},
  },
];
export const breadcrumbLinkSocialImport = () => [
  {
    label: "Customers",
    link:routes.CUSTOMERLIST,
  },
  {
    label: "Social Import",
    link: routes.SOCIALIMPORT_CUSTOMER,
    handleClick: () => {},
  },
];

export const customerEditableFields = [
  { label: "Customer Owner", id: 1, value: "customerOwner" },
  { label: "Company", id: 3, value: "company"},
  { label: "Fax", id: 4, value: "fax" },
  { label: "Description", id: 6, value: "description" },
  { label: "Preferred Contact Mode", id: 7, value: "preferredContactMode" }
];
